var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiramax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "154.008px",
    viewBox: "0 0 1000 154.008",
    enableBackground: "new 0 0 1000 154.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "114.661,0.017 83.629,42.389 52.527,0.017 0.025,0.017 0,153.991 52.499,153.991 52.499,92.446 83.629,134.917  114.661,92.446 114.661,154.004 167.252,154.008 167.252,0.017 114.661,0.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.795,154.004 239.204,154.004 239.204,0.037 177.795,0.037 177.795,154.004  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.77,93.958l10.645-38.921l10.639,38.921H763.77L763.77,93.958z M447.775,93.958l10.739-39.03l10.753,39.03H447.775 L447.775,93.958z M316.778,74.524h-14.34V42.84c0,0,8.666-0.006,14.311,0c7.935,0.012,17.569,1.33,17.569,15.84 C334.318,72.234,325.747,74.524,316.778,74.524 M945.315,76.975l54.613-76.932h-64.057l-22.584,31.811L890.706,0.043h-64.057 l54.613,76.932l-29.645,41.76l-0.057-0.057L803.637,0.025h-58.455l-45.404,113.024L699.737,0h-52.273l-31.316,42.43L585.02,0 h-52.541v110.698L487.75,0.025h-58.455L376.46,131.297l-16.561-23.348c29.059-16.881,28.009-49.697,27.998-49.685 c0,0,1.113-32.937-29.051-49.64c-12.686-7.024-25.193-8.606-45.667-8.606h-63.424v153.986h52.682v-36.77l26.066,36.77 l102.822-0.018l5.226-18.996h43.937l5.197,18.996l99.334,0.018V92.448l31.127,42.512l31.035-42.512v61.557h100.162l5.211-19.014 h43.721l5.227,19.014h89.131l22.654-31.916l22.664,31.916H1000L945.315,76.975L945.315,76.975z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiramax);
export default __webpack_public_path__ + "static/media/Miramax.ea988a8649b4fbdb519400038f589aa3.svg";
export { ForwardRef as ReactComponent };